<template>
  <div v-if="sendInfo" class="move-fedexreturn">
    <i-spin v-if="loading" fix>
      <i-icon type="ios-loading" size="40" class="spin-icon-load" />
    </i-spin>
    <template v-else>
      <div class="time">
        <img class="img" src="../../assets/imgs/send-fedex.png" alt="send-fedex" />
        <div class="time-info">
          <p class="title">Receive on {{ returnInfo.recvLdt | time }}</p>
          <span class="tag">{{ returnInfo.signType | signType }}</span>
        </div>
      </div>
      <div class="ship-info">
        <div class="row">
          <div class="long">
            <p class="title">Receiver name</p>
            <p class="value">{{ returnInfo.sendFirstName }} {{ returnInfo.sendLastName }}</p>
          </div>
          <div class="shot">
            <p class="title">Phone number</p>
            <p class="value">{{ returnInfo.sendMobile }}</p>
          </div>
        </div>
        <div class="row">
          <div class="long">
            <p class="title">State/Province, City</p>
            <p class="value">{{ returnInfo.sendCity }}, {{ returnInfo.sendState }} {{ returnInfo.sendCountry }}</p>
          </div>
          <div class="shot">
            <p class="title">Zip code</p>
            <p class="value">{{ returnInfo.sendPostcode }}</p>
          </div>
        </div>
        <div class="row">
          <div class="long">
            <p class="title">Shipping address</p>
            <p class="value">{{ returnInfo.sendAddr1 }}</p>
            <p class="value">{{ returnInfo.sendAddr2 }}</p>
          </div>
        </div>
        <div class="row">
          <div class="long">
            <i-divider style="margin-top: 0; margin-bottom: 20px" />
            <p class="title">Shipping insurance</p>
            <p class="value">
              <i-table border size="small" :columns="insuranceColumns" :data="returnInfo.insurances" />
            </p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { API } from '@/net/http';
import moment from 'moment';
export default {
  name: 'FedexReturn',
  filters: {
    signType(signType) {
      switch (signType) {
        case 'DIRECT':
          return 'Direct Signature';
        case 'ADULT':
          return 'Adult Signature';
        default:
          return 'No signature Required';
      }
    },
    time(time) {
      return moment(time, 'MM/DD/yy').format('MM/DD/YYYY');
    },
  },
  props: ['backId'],
  data() {
    return {
      returnInfo: {},
      loading: false,
      sendInfo: {},
      insuranceColumns: [
        {
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: 'Insurance',
          key: 'desc',
          align: 'center',
        },
      ],
    };
  },
  watch: {
    backId: function () {
      this.initBackInfo();
    },
  },
  mounted() {
    this.initBackInfo();
  },
  methods: {
    initBackInfo() {
      if (this.backId === null) return;

      this.loading = true;
      this.$post(API.orderBackInfo, {
        backId: this.backId,
      })
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.returnInfo = res.data;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/main.less';
@import '../../assets/fonts/font.less';

.move-fedexreturn {
  position: relative;
  width: 100%;
  min-height: 200px;
  box-shadow: 0 2px 8px 0 rgba(207, 207, 207, 0.2);
  .time {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 90px;
    img {
      width: 79px;
      padding-bottom: 25px;
    }
    .time-info {
      flex: 1;
      height: 100%;
      padding-left: 46px;
      .title {
        .font-light;
        font-size: 18px;
        font-weight: 300;
        line-height: 22px;
        color: @app-black-color;
      }
      .tag {
        color: #fff;
        height: 26px;
        margin-top: 10px;
        display: inline-block;
        background: @app-tag-color;
        border-radius: 13px;
        font-family: 'Montserrat-Light';
        font-size: 14px;
        font-weight: 300;
        margin-left: 10px;
        line-height: 26px;
        padding: 0 20px;
      }
    }
  }
  .ship-info {
    border-top: 1px solid #eeeff0;
    .row {
      margin-top: 36px;
      display: flex;
      flex-direction: row;
      .shot {
        width: 144px;
        height: 100%;
      }
      .long {
        flex: 1;
        height: 100%;
      }
      .title {
        .font-light;
        color: @app-black-color;
        font-size: 14px;
        font-weight: 300;
      }
      .value {
        .font-regular;
        padding-top: 10px;
        color: @app-black-color;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
}
</style>
